import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "3b389893-d127-4e29-8a22-0c8d568221f8",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "652d485f-ba17-4010-bbee-68e83f339b84",
      type: "Sprite",
      name: "slot",
      nameSpace: "",
      className: "small",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "Polygon",
        path: "0,-35, 60,-3, 0,60, -60,-3, 0,-35"
      },
      texture: "base_texture",
      parent: "3b389893-d127-4e29-8a22-0c8d568221f8",
      data: ""
    },
    {
      id: "ad0b8644-256a-4eff-b65e-dc0ebcaf70a5",
      type: "Container",
      name: "itemContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60",
      type: "Container",
      name: "taskIcon",
      nameSpace: "",
      className: "",
      x: 0,
      y: 50,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "c2dab7cd-50b2-43e1-9109-37c6e7bf67bd",
      type: "Container",
      name: "replyTaskIcon",
      nameSpace: "",
      className: "",
      x: 0,
      y: 50,
      scale: {
        x: 0.75,
        y: 0.75
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "04a9727e-fd7d-45f3-bc36-f4709592ea64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_bg",
      parent: "cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60",
      data: ""
    },
    {
      id: "69f5185d-0576-44d4-9c7d-581d506dbea8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_bg",
      parent: "c2dab7cd-50b2-43e1-9109-37c6e7bf67bd",
      data: ""
    },
    {
      id: "66f34045-5342-4fb0-8847-c125d11961de",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_small",
      parent: "04a9727e-fd7d-45f3-bc36-f4709592ea64",
      data: ""
    },
    {
      id: "68a375af-beac-4ae5-a308-c16fc4ad91dc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_small",
      parent: "69f5185d-0576-44d4-9c7d-581d506dbea8",
      data: ""
    },
    {
      id: "6354fa1d-2a1a-4052-ba5e-2a7d4c54aec8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 25,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task",
      parent: "69f5185d-0576-44d4-9c7d-581d506dbea8",
      data: ""
    }
  ]
} as const;

export class SmallSlotLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  slot: GameObject<PIXI.Sprite>;
  itemContainer: GameObject<PIXI.Container>;
  taskIcon: GameObject<PIXI.Container>;
  replyTaskIcon: GameObject<PIXI.Container>;
  small: (GameObject<PIXI.Sprite>)[];

  constructor() {
    populate(this, raw);
  }
}
